<template>
  <div class="wrp">
    <header>
      <p>{{ getName }}</p>
    </header>
    <section>
      <div class="tip">
        <p class="title">
          <span class="iconfont">&#xe6e3;</span>开票结果查询
        </p>
        <ul class="content">
          <li>1、接受申请24小时内发送电子发票</li>
          <li>2、通过预留邮箱查询</li>
        </ul>
      </div>
      <div class="invoice" >
        <swiper :options="swiperOption" ref="mySwiper" @someSwiperEvent="swiperCallback" >
          <swiper-slide v-for="(item,i) in invoiceDetails" :key="i">
            <div class="img-wrp">
              <InvoiceCanvas v-if="item.id" @click.native="onShowCanvas(i)" :invoiceData="item" ref="invoiceCanvasRef" class="invoicePic"></InvoiceCanvas>
            </div>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination" v-show="isPagination"></div>
        </swiper>
      </div>
      <!-- <div class="footer">
        <div class="company-info">
          <p class="iconfont">&#xe614;</p>
          <p class="company-name">
            慧穗数字科技（上海）有限公司
          </p>
          <div class="scantip">扫描二维码，关注公众号</div>
        </div>
        <div class="qrcode-wrp">
          <img src="@assets/img/qrcode.jpeg" alt="">
        </div>
      </div> -->
    </section>
    <ImagePreview @onClose="onPreviewClose" :visible="previewShow" :img="img" />
  </div>
</template>

<script>
import InvoiceCanvas from '@components/InvoiceCanvas/index.vue'
import ImagePreview from '@components/ImagePreview'
import { Icon, SwipeItem, Swipe, Toast, Notify } from 'vant'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { ConvertNumber, getQuery, deepCopy } from '@utils/basicUtil'
import { businessRequest } from '@services'
import { platformConfig } from '@assets/config'
export default {
  data () {
    return {
      swiperList: [
        'https://smarttax-basic.oss-cn-shanghai.aliyuncs.com/resource/huixiaopiao-miniprogram/banner1.png',
        'https://smarttax-basic.oss-cn-shanghai.aliyuncs.com/resource/huixiaopiao-miniprogram/banner2.png',
        'https://smarttax-basic.oss-cn-shanghai.aliyuncs.com/resource/huixiaopiao-miniprogram/banner3.png'
      ],
      company: '',
      money: '0',
      phone: '',
      email: '',
      data: {
        id: '',
        purchaserName: '',
        purchaserTaxNo: '',
        purchaserTelAndAdress: '',
        purchaserBankNameAndAccount: '',
        sellerInvoiceDetails: [],
        sellerTelAndAdress: '',
        sellerBankNameAndAccount: ''
      },
      invoiceDetails: [],
      invoiceData: {},
      previewShow: false,
      img: '',
      swiperOption: {
        // 循环
        loop: true,
        // 滑动速度
        speed: 500,
        // delay:1000
        pagination: {
          el: '.swiper-pagination',
          // type: 'fraction'
          dynamicBullets: true
        }
      },
      isPagination: false
    }
  },
  mounted () {
    this.getQuery()
    this.getInvoice()
    setTimeout(() => {
      this.data.purchaserTelAndAdress = 1111111
      this.data = deepCopy(this.data)
    }, 3000)
  },
  methods: {
    async getQuery () {
      let queryObj = getQuery()
      this.id = queryObj.invoiceId
    },
    ConvertNumber (num) {
      return ConvertNumber(num)
    },
    onShowCanvas (index) {
      let src = this.$refs.invoiceCanvasRef[index].$refs.imgRef.children[0].src
      this.previewShow = true
      this.img = src
    },
    onImageChange (index) {
      this.index = index
    },
    async getInvoice (orderNo) {
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0
      })
      let time = null
      time = setInterval(async () => {
        const data = await businessRequest.qrcode.getInvoiceBySettlementId({ settlementId: this.id })
        if (data.success) {
          if (data.result && data.result.length && data.result[0].drewDate) {
            Toast.clear({
              clearAll: true
            })
            clearInterval(time)
            this.invoiceDetails = deepCopy(data.result)
            this.invoiceDetails.forEach(v => {
              if (v.details.length <= 8) {
                v.sellerInvoiceDetails = v.details
              } else if (v.details.length > 8) {
                v.sellerInvoiceDetails = v.details.slice(0, 8)
                v.sellerInvoiceDetails[7].goodsName = '...'
                v.sellerInvoiceDetails[7].shortName = '...'
                v.sellerInvoiceDetails[7].specification = '...'
                v.sellerInvoiceDetails[7].unit = '...'
                v.sellerInvoiceDetails[7].quantity = '...'
                v.sellerInvoiceDetails[7].unitPrice = '...'
                v.sellerInvoiceDetails[7].amount = '...'
                v.sellerInvoiceDetails[7].taxRate = '...'
                v.sellerInvoiceDetails[7].taxAmount = '...'
              }
            })
            if (this.invoiceDetails.length > 1) {
              this.isPagination = true
            }
          }
        } else {
          Toast.clear({
            clearAll: true
          })
          if (data.success === false) {
            Notify({ type: 'danger', message: data.message })
            clearInterval(time)
          }
        }
      }, 2000)
      // qrcode.getInvoiceBySettlementId
    },
    onPreviewClose () {
      this.previewShow = false
    },
    swiperCallback (a, b, c) {

    }
  },
  computed: {
    getName () {
      return platformConfig.getAllName()
    }
  },
  components: {
    InvoiceCanvas,
    [Icon.name]: Icon,
    [SwipeItem.name]: SwipeItem,
    [Swipe.name]: Swipe,
    [Toast.name]: Toast,
    swiper,
    swiperSlide,
    ImagePreview
  }
}
</script>

<style lang="less" scoped src="./index.less"/>
